// @ts-nocheck
import { Streami18n } from 'stream-chat-react'
import dayjs from '../../../dayjsConfig'
import { currentLang, currentLangString } from '../../../i18nInit'
import { Lang } from '../../../services/api.types'
import { TranslationLanguages } from 'stream-chat'

// Get Stream language type is missing Lithuanian
type TranslationLanguagesUpdated = TranslationLanguages & 'lt' & 'pa' & 'fil' & 'my'

import sqTranslation from './sq.json'
import arTranslation from './ar.json'
import bgTranslation from './bg.json'
import zhTranslation from './zh-Hans.json'
import hrTranslation from './hr.json'
import csTranslation from './cs.json'
import daTranslation from './da.json'
import etTranslation from './et.json'
import fiTranslation from './fi.json'
import elTranslation from './el.json'
import heTranslation from './he.json'
import huTranslation from './hu.json'
import lvTranslation from './lv.json'
import ltTranslation from './lt.json'
import noTranslation from './no.json'
import plTranslation from './pl.json'
import roTranslation from './ro.json'
import srTranslation from './sr.json'
import skTranslation from './sk.json'
import slTranslation from './sl.json'
import svTranslation from './sv.json'
import ukTranslation from './uk.json'

import idTranslation from './id.json'
import thTranslation from './th.json'
import viTranslation from './vi.json'

import deTranslation from './replacements/de.json'
import enTranslation from './replacements/en.json'
import esTranslation from './replacements/es.json'
import frTranslation from './replacements/fr.json'
import itTranslation from './replacements/it.json'
import jaTranslation from './replacements/ja.json'
import koTranslation from './replacements/ko.json'
import nlTranslation from './replacements/nl.json'
import ptTranslation from './replacements/pt.json'
import ruTranslation from './replacements/ru.json'
import trTranslation from './replacements/tr.json'

// Added in 2025 (12 new):
import hiTranslation from './replacements/hi.json'
import zhTwTranslation from './zh-Hant.json'
import bnTranslation from './bn.json'
import paTranslation from './pa.json'
import urTranslation from './ur.json'
import faTranslation from './fa.json'
import msTranslation from './ms.json'
import filTranslation from './fil.json'
import swTranslation from './sw.json'
import haTranslation from './ha.json'
import myTranslation from './my.json'
import taTranslation from './ta.json'

const language =
  currentLang === Lang.ZH_HANS
    ? 'zh'
    : currentLang === Lang.ZH_HANT
      ? 'zh-TW'
      : currentLang === Lang.PT_BR
        ? 'pt'
        : (currentLangString as TranslationLanguagesUpdated)

const i18nInstance = new Streami18n({
  language,
  DateTimeParser: dayjs,
})

switch (currentLang) {
  case Lang.AR:
    i18nInstance.registerTranslation('ar', arTranslation)
    break
  case Lang.BG:
    i18nInstance.registerTranslation('bg', bgTranslation)
    break
  case Lang.CS:
    i18nInstance.registerTranslation('cs', csTranslation)
    break
  case Lang.DA:
    i18nInstance.registerTranslation('da', daTranslation)
    break
  case Lang.EL:
    i18nInstance.registerTranslation('el', elTranslation)
    break
  case Lang.ET:
    i18nInstance.registerTranslation('et', etTranslation)
    break
  case Lang.FI:
    i18nInstance.registerTranslation('fi', fiTranslation)
    break
  case Lang.HR:
    i18nInstance.registerTranslation('hr', hrTranslation)
    break
  case Lang.HE:
    i18nInstance.registerTranslation('he', heTranslation)
    break
  case Lang.HU:
    i18nInstance.registerTranslation('hu', huTranslation)
    break
  case Lang.ID:
    i18nInstance.registerTranslation('id', idTranslation)
    break
  case Lang.LT:
    i18nInstance.registerTranslation(<TranslationLanguagesUpdated>'lt', ltTranslation)
    break
  case Lang.LV:
    i18nInstance.registerTranslation('lv', lvTranslation)
    break
  case Lang.NO:
    i18nInstance.registerTranslation('no', noTranslation)
    break
  case Lang.PL:
    i18nInstance.registerTranslation('pl', plTranslation)
    break
  case Lang.RO:
    i18nInstance.registerTranslation('ro', roTranslation)
    break
  case Lang.SK:
    i18nInstance.registerTranslation('sk', skTranslation)
    break
  case Lang.SL:
    i18nInstance.registerTranslation('sl', slTranslation)
    break
  case Lang.SQ:
    i18nInstance.registerTranslation('sq', sqTranslation)
    break
  case Lang.SR:
    i18nInstance.registerTranslation('sr', srTranslation)
    break
  case Lang.SV:
    i18nInstance.registerTranslation('sv', svTranslation)
    break
  case Lang.UK:
    i18nInstance.registerTranslation('uk', ukTranslation)
    break
  case Lang.ZH_HANS:
    i18nInstance.registerTranslation('zh', zhTranslation)
    break
  case Lang.TH:
    i18nInstance.registerTranslation('th', thTranslation)
    break
  case Lang.VI:
    i18nInstance.registerTranslation('vi', viTranslation)
    break
  // Official translation replacements:
  case Lang.EN:
    i18nInstance.registerTranslation('en', enTranslation)
    break
  case Lang.DE:
    i18nInstance.registerTranslation('de', deTranslation)
    break
  case Lang.ES:
    i18nInstance.registerTranslation('es', esTranslation)
    break
  case Lang.FR:
    i18nInstance.registerTranslation('fr', frTranslation)
    break
  case Lang.IT:
    i18nInstance.registerTranslation('it', itTranslation)
    break
  case Lang.JA:
    i18nInstance.registerTranslation('ja', jaTranslation)
    break
  case Lang.KO:
    i18nInstance.registerTranslation('ko', koTranslation)
    break
  case Lang.NL:
    i18nInstance.registerTranslation('nl', nlTranslation)
    break
  case Lang.PT:
  case Lang.PT_BR:
    i18nInstance.registerTranslation('pt', ptTranslation)
    break
  case Lang.RU:
    i18nInstance.registerTranslation('ru', ruTranslation)
    break
  case Lang.TR:
    i18nInstance.registerTranslation('tr', trTranslation)
    break

  // TODO: Added in 2025 (12 new):
  case Lang.ZH_HANT:
    i18nInstance.registerTranslation('zh-TW', zhTwTranslation)
    break
  case Lang.HI:
    i18nInstance.registerTranslation('hi', hiTranslation)
    break
  case Lang.BN:
    i18nInstance.registerTranslation('bn', bnTranslation)
    break
  case Lang.PA:
    i18nInstance.registerTranslation(<TranslationLanguagesUpdated>'pa', paTranslation)
    break
  case Lang.UR:
    i18nInstance.registerTranslation('ur', urTranslation)
    break
  case Lang.FA:
    i18nInstance.registerTranslation('fa', faTranslation)
    break
  case Lang.MS:
    i18nInstance.registerTranslation('ms', msTranslation)
    break
  case Lang.FIL:
    i18nInstance.registerTranslation(<TranslationLanguagesUpdated>'fil', filTranslation)
    break
  case Lang.SW:
    i18nInstance.registerTranslation('sw', swTranslation)
    break
  case Lang.HA:
    i18nInstance.registerTranslation('ha', haTranslation)
    break
  case Lang.MY:
    i18nInstance.registerTranslation(<TranslationLanguagesUpdated>'my', myTranslation)
    break
  case Lang.TA:
    i18nInstance.registerTranslation('ta', taTranslation)
    break

  default:
    console.error('Missing translation for chat.')
    break
}

export default i18nInstance
